import { useSelector } from 'react-redux'
import styled, { css } from 'styled-components'

import { ServiceTypeLogo } from '@components/logos'
import { AppBar, Toolbar } from '@components/ui'
import { LocaleSelector } from '@oldComponents/LocaleSelector'

import { LINKS, ROUTES } from '@constants'

const LogoContainer = styled.div`
  display: flex;
  align-items: center;

  & a {
    display: inherit;
  }
`

const CenteredLogoContainer = styled(LogoContainer)`
  flex: 1;
  justify-content: flex-start;
`

// Hidden rather than unmounted, so the bar keeps its space and the content below does not jump.
const StyledAppBar = styled(AppBar)<{ $isHidden: boolean }>`
  ${({ $isHidden }) =>
    $isHidden &&
    css`
      opacity: 0;
      pointer-events: none;
    `}
`

interface PublicNavbarProps {
  isHidden?: boolean
  withExtraDesign: boolean
}

export function PublicNavbar({ isHidden = false, withExtraDesign }: PublicNavbarProps) {
  const isLoggedIn = useSelector((state: Store) => state.auth.isLoggedIn)
  const Container = withExtraDesign ? CenteredLogoContainer : LogoContainer
  const tabIndex = isHidden ? -1 : undefined

  return (
    <StyledAppBar color="default" $isHidden={isHidden} aria-hidden={isHidden || undefined}>
      <Toolbar>
        <Container>
          <a href={isLoggedIn ? ROUTES.root : LINKS.szamlazz} tabIndex={tabIndex}>
            <ServiceTypeLogo />
          </a>
        </Container>
        <LocaleSelector />
      </Toolbar>
    </StyledAppBar>
  )
}
